import RugbyHeader from "../../components/header/rugby-header"

import './firstplayer.css'

import player_photo from './player-profile-stumb.png'
const FirstPlayer = () => {
    return (
        <>
        <RugbyHeader/>
            <section class="player-profile current-player">
                <div class="container">
                    <div class="player-profile__box">
                        <div class="player-profile__photo"><img src={player_photo} alt="playerPhoto" /></div>
                        <div class="player-profile__info">
                            <div class="player-profile__subtitle">PLAYER PROFILE</div>
                            <h2 class="player-profile__title player-name">NAME SURNAME</h2>
                            <div class="player-profile__role">Mid-fielder</div>

                            <div class="player-profile__keystats">

                                <h4 class="player-profile__keystats_title">KEY STATS</h4>


                                <ul class="player-profile__keystats_box">

                                    <li class="player-profile__keystat"><span class="player-profile__keystat_title">AGE</span>
                                        <div class="player-profile__keystat_num">18</div>
                                    </li>

                                    <li class="player-profile__keystat"><span
                                        class="player-profile__keystat_title">WEIGHT</span>
                                        <div class="keystat-box">
                                            <a class="player-profile__keystat_num">70</a><span class="cmkg-stumb">KG</span>
                                        </div>
                                    </li>

                                    <li class="player-profile__keystat"><span
                                        class="player-profile__keystat_title">HEIGHT</span>
                                        <div class="keystat-box">
                                            <a class="player-profile__keystat_num">180</a><span class="cmkg-stumb">CM</span>
                                        </div>
                                    </li>

                                    <li class="player-profile__keystat"><span class="player-profile__keystat_title">GAMES</span>
                                        <div class="player-profile__keystat_num">50</div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div class="player-bio">
                        <div class="player-bio__title">BIOGRAPHY</div>
                        <div class="player-bio__descr"><b>Lorem ipsum dolor sit amet consectetur</b>, adipisicing elit. Eligendi
                            hic,
                            optio dolore molestias distinctio soluta sit asperiores minima aut, repudiandae alias explicabo
                            laudantium. Laborum eveniet harum illo ipsum libero est.
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestias nisi doloremque quidem
                            minus beatae odio totam rem esse tenetur doloribus ad, deserunt fugit porro, obcaecati illum,
                            deleniti consectetur. Recusandae.
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FirstPlayer
